<template>
    <div class="course-item">
        <div class="content-wrapper" :class="{ 'slider-active': showCourseInfo }">
            <router-link
                v-if="course"
                :to="isExpired || isWatchListItemInEditMode ? '' : getRouteToCourse(course)"
                :class="{ 'expired': isExpired }"
            >
                <div :class="['course-item__image-box', { 'expired': isExpired }]">
                    <ThumbnailBackgroundImage :course="course"/>
                    <ThumbnailForegroundLogo :course="course"/>
                    <ThumbnailPartnerLogo :course="course"/>
                    <ThumbnailInstructors :course="course"/>
                    <ThumbnailWatchlistItems :entity="course" :index="index" :editable="editable"
                                             v-if="isWatchListItem"/>
                </div>
                <div class="course-item__info-box">
                    <span class="course-item__title">{{ course.title | truncate(110) }}</span>
                    <ThumbnailInfoTable itemType="course" :entity="course"/>
                    <ThumbnailTags :course="course" :isUncompletedItem="isUnCompletedView"
                                   :isCompletedItem="isCompletedView"/>
                    <TotemLockIcon v-if="userHasNoAccess"/>
                </div>
            </router-link>
        </div>
        <ThumbnailActions
            @show-course-info="showCourseInfoDiv"
            :entity="course"
            itemType="course"
            :isCompletedView="isCompletedView"
            :isUnCompletedView="isUnCompletedView"
            :isWatchListItem="isWatchListItem"
        />
        <div class="slide-container">
            <div class="slide-div" :class="{ 'active': showCourseInfo, 'inactive': !showSlider }"
                 @animationend="onAnimationEnd">
                <ThumbnailDetails itemType="course" :entity="course"/>
            </div>
        </div>
    </div>
</template>

<script>
    import CourseItemHelper from 'components/shared/global-courses-items/helper/course-item-helper'
    import ThumbnailInfoTable from 'components/shared/global-courses-items/thumbnails/ThumbnailInfoTable.vue'
    import ThumbnailTags from 'components/shared/global-courses-items/thumbnails/ThumbnailTags.vue'
    import ThumbnailActions from 'components/shared/global-courses-items/thumbnails/ThumbnailActions.vue'
    import ThumbnailDetails from 'components/shared/global-courses-items/thumbnails/ThumbnailDetails'
    import ThumbnailInstructors from 'components/shared/global-courses-items/thumbnails/ThumbnailInstructors.vue'
    import ThumbnailWatchlistItems from 'components/shared/global-courses-items/thumbnails/ThumbnailWatchlistItems.vue'
    import ThumbnailMoreInfoHelper from 'components/shared/global-courses-items/helper/thumbnail-more-info-helper'
    import ThumbnailPartnerLogo from 'components/shared/global-courses-items/thumbnails/ThumbnailPartnerLogo.vue'
    import ThumbnailForegroundLogo from 'components/shared/global-courses-items/thumbnails/ThumbnailForegroundLogo.vue'
    import ThumbnailBackgroundImage
        from 'components/shared/global-courses-items/thumbnails/ThumbnailBackgroundImage.vue'

    export default {
        name: 'totem-course-item-mosaic',
        components: {
            ThumbnailInfoTable,
            ThumbnailTags,
            ThumbnailActions,
            ThumbnailDetails,
            ThumbnailInstructors,
            ThumbnailWatchlistItems,
            ThumbnailPartnerLogo,
            ThumbnailForegroundLogo,
            ThumbnailBackgroundImage
        },
        mixins: [CourseItemHelper, ThumbnailMoreInfoHelper]
    }
</script>

<style lang="scss" scoped>
@include totem_thumbnail_item_mosaic;
@include totem_thumbnail_more_info;
</style>
